export default __webpack_public_path__ + "static/media/Icon material-supervisor-account.b7ea18ae.svg";